import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgSearch(props: RootSvgProps) {
  return (
    <RootSvg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7843 11.7435L15.7828 14.6909C16.0834 14.9904 16.0333 15.4893 15.7828 15.7398C15.6389 15.8914 15.4416 15.9809 15.2328 15.9892C15.0335 15.9892 14.8331 15.889 14.6838 15.7398L11.6842 12.7935C8.78589 14.9403 4.73632 14.6408 2.13752 12.1433L1.98829 11.993C-0.711781 9.24601 -0.661681 4.80097 2.13752 2.10411C4.98682 -0.692962 9.58535 -0.692962 12.3846 2.05401C15.1337 4.65174 15.2829 8.89744 12.7843 11.7435ZM7.28609 1.50504C4.13725 1.50504 1.58749 4.00151 1.53845 7.09918C1.55385 8.60468 2.16932 10.0418 3.24833 11.0918C4.32735 12.1418 5.78072 12.7179 7.28609 12.6922C10.3848 12.7423 12.9836 10.2448 13.0337 7.09918C12.9836 4.00151 10.4349 1.50504 7.28609 1.50504Z"
        fill="currentColor"
      />
    </RootSvg>
  );
}
